// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.SolidGauge.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import 'share/utils/Izenda.StringUtilities';

import HighchartUtils from './Izenda.HighchartUtils';
import { getOr, isFunction, get } from 'lodash/fp';
export default H => {
  const WIDTH = 300;
  const HEIGHT = 200;
  const FONT_SIZE_TITLE = 10;
  const FONT_SIZE_VALUE = 13;
  const FONT_SIZE_UNIT = 8;

  const INNER_RADIUS = 100;

  const DATA_THICKNESS = 50;
  const DATA_BACKGROUND_COLOR = '#f2f2f2';
  const START_ANGLE = -90;
  const END_ANGLE = 90;

  const BASE_CHART = 'solidgauge';
  const IZENDA_CHART = 'izendaSolidGauge';

  const defaultPlotOptions = H.getOptions().plotOptions,
    baseChart = H.seriesTypes[BASE_CHART],
    wrap = H.wrap;

  defaultPlotOptions[IZENDA_CHART] = H.merge(defaultPlotOptions[BASE_CHART], {});

  H.seriesTypes[IZENDA_CHART] = H.extendClass(baseChart, {
    type: IZENDA_CHART
  });

  /** OVERRIDE HIGHCHART FUNCTION **/
  wrap(H.Chart.prototype, 'init', function(proceed: any, userOptions: any, callback: any): any {
    const chartType = userOptions.chart.type;

    if (chartType === IZENDA_CHART) {
      userOptions = H.merge(userOptions, {
        chart: {
          margin: [FONT_SIZE_TITLE * 2, 0, 0, 0],
          spacing: [0, 0, 0, 0],
          height: HEIGHT,
          width: WIDTH
        },
        pane: {
          center: ['50%', '65%'],
          size: '85%',
          startAngle: START_ANGLE,
          endAngle: END_ANGLE,
          background: {
            backgroundColor: DATA_BACKGROUND_COLOR,
            innerRadius: '100%',
            outerRadius: 100 + DATA_THICKNESS + '%',
            shape: 'arc'
          }
        },
        plotOptions: {
          series: {
            innerRadius: '100%',
            radius: 100 + DATA_THICKNESS + '%',
            dataLabels: getDataLabelOptions(get('plotOptions.series.dataLabels', userOptions))
          }
        },
        yAxis: getYaxis(userOptions.yAxis)
      });
    }

    proceed.call(this, userOptions, callback);

    function getYaxis(yAxis: any): any {
      return {
        stops: yAxis.plotBands && yAxis.plotBands.length > 0 ?
          yAxis.plotBands.map(
            function (band) {
              return [(band.from + band.to) / (2 * Math.max(yAxis.max - yAxis.min, Math.max(band.to - band.from, 1))), band.color]
            }) :
          null,
        tickPositions: [yAxis.min, yAxis.max],
        innerRadius: INNER_RADIUS + '%',
        labels: getLabelOptions()
      };

      function getLabelOptions() {
        const formatter = get('yAxis.labels.formatter', userOptions);

        return {
          formatter: getFormatLabel,
          distance: 15,
          y: 20
        };

        function getFormatLabel() {
          const val = isFunction(formatter) ? formatter.call(this) : this.value;
          return String.format('<span style="font-size:{0}px">{1}</span>', FONT_SIZE_TITLE, val);
        }
      }
    }

    function getDataLabelOptions(userOptionsDataLabels: any): any {
      const formatter = userOptionsDataLabels.formatter;

      return {
        crop: false,
        overflow: 'none',
        enabled: true,
        useHTML: true,
        y: 0,
        borderWidth: 0,
        formatter() {
          const point = this.point;
          const pointOpts = HighchartUtils.getPointOptions(point);
          const pointVal = HighchartUtils.getPointValue(point);
          const chart = this.series.chart;
          const width = chart.plotWidth / 3;
          const val = formatter ? formatter.apply(this, arguments) : pointVal;
          const unitLabel = getOr('', 'series.chart.options.izendaOptions.dataUnit', this);

          return String.format(
            '<div class="solid-gauge-datalabels" style="text-align: center;width:{4}px; color:{5}">' +
              '<p class="value overflow-text" style="font-size:{0}px; margin:0" title="{1}">{1}</p>' +
              '<p class="unit overflow-text" style="font-size:{2}px; margin:0" title="{3}">{3}</span></p>',
            FONT_SIZE_VALUE,
            val,
            FONT_SIZE_UNIT,
            unitLabel,
            width,
            get('textColor', pointOpts)
          );
        }
      };
    }
  });
};



// WEBPACK FOOTER //
// ./ui/share/components/charting/highcharts/Izenda.SolidGauge.js